import { Effect, Reducer } from 'umi';
import { getRecentPeopleViewed, getRecentProductViewed, getRecentLists, getTopIngredientsAndPackaging } from './service';

export interface DashboardModelState {
  recentPeople: any[];
  recentProducts: any[];
  recentLists: any[];
  topIngredientsAndPackaging: {
    topIngredients: Array<{
      count: string;
      name: string;
      id: number;
    }>;
    topPackaging: Array<{
      count: string;
      name: string;
    }>;
  };
  loading: {
    people: boolean;
    products: boolean;
    lists: boolean;
    ingredients: boolean;
  };
}

export interface DashboardModelType {
  namespace: 'dashboard';
  state: DashboardModelState;
  effects: {
    fetchRecentPeople: Effect;
    fetchRecentProducts: Effect;
    fetchRecentLists: Effect;
    fetchTopIngredientsAndPackaging: Effect;
  };
  reducers: {
    setRecentPeople: Reducer<DashboardModelState>;
    setRecentProducts: Reducer<DashboardModelState>;
    setRecentLists: Reducer<DashboardModelState>;
    setTopIngredientsAndPackaging: Reducer<DashboardModelState>;
    setLoading: Reducer<DashboardModelState>;
  };
}

const DashboardModel: DashboardModelType = {
  namespace: 'dashboard',
  state: {
    recentPeople: [],
    recentProducts: [],
    recentLists: [],
    topIngredientsAndPackaging: {
      topIngredients: [],
      topPackaging: [],
    },
    loading: {
      people: false,
      products: false,
      lists: false,
      ingredients: false,
    },
  },
  effects: {
    *fetchRecentPeople(_: any, { call, put }: { call: any; put: any }): Generator<any, void, any> {
      yield put({ type: 'setLoading', payload: { people: true } });
      try {
        console.log('fetching recent people');
        const response = yield call(getRecentPeopleViewed);
        yield put({ type: 'setRecentPeople', payload: response });
      }
      catch (error) {
        console.log('Error fetching recent people:', error);
      }
      finally {
        yield put({ type: 'setLoading', payload: { people: false } });
      }
    },
    *fetchRecentProducts(_: any, { call, put }: { call: any; put: any }): Generator<any, void, any> {
      yield put({ type: 'setLoading', payload: { products: true } });
      try {
        const response = yield call(getRecentProductViewed);
        yield put({ type: 'setRecentProducts', payload: response });
      } finally {
        yield put({ type: 'setLoading', payload: { products: false } });
      }
    },
    *fetchRecentLists(_: any, { call, put }: { call: any; put: any }): Generator<any, void, any> {
      yield put({ type: 'setLoading', payload: { lists: true } });
      try {
        const response = yield call(getRecentLists);
        yield put({ type: 'setRecentLists', payload: response });
      } finally {
        yield put({ type: 'setLoading', payload: { lists: false } });
      }
    },
    *fetchTopIngredientsAndPackaging(_: any, { call, put }: { call: any; put: any }): Generator<any, void, any> {
      yield put({ type: 'setLoading', payload: { ingredients: true } });
      try {
        const response = yield call(getTopIngredientsAndPackaging);
        yield put({ type: 'setTopIngredientsAndPackaging', payload: response });
      } finally {
        yield put({ type: 'setLoading', payload: { ingredients: false } });
      }
    },
  },
  reducers: {
    setRecentPeople(state, { payload }) {
      return { ...state, recentPeople: payload };
    },
    setRecentProducts(state, { payload }) {
      return { ...state, recentProducts: payload };
    },
    setRecentLists(state, { payload }) {
      return { ...state, recentLists: payload };
    },
    setTopIngredientsAndPackaging(state, { payload }) {
      return { ...state, topIngredientsAndPackaging: payload };
    },
    setLoading(state, { payload }) {
      return {
        ...state,
        loading: { ...state.loading, ...payload },
      };
    },
  },
};

export default DashboardModel; 